/**
 * ตัวจัดรูปแบบข้อความของรอบอบรม — การ์ดคำเชิญ / รอบที่จองไว้ / หลักสูตรที่เปิดรับ
 * ต้องอ่านออกมาหน้าตาเดียวกัน (ยกมาจาก bangbow-website-new-dev lib/training-format.ts)
 */

/** "09:00 - 12:00" — ตัดวินาทีที่ pg คืนมากับคอลัมน์ TIME ทิ้ง */
export const timeRange = (start?: string | null, end?: string | null): string =>
  [start, end]
    .map(t => (t ? t.slice(0, 5) : ''))
    .filter(Boolean)
    .join(' - ')

/** ที่นั่งคงเหลือของรอบ — `seats_left = null` หรือไม่กำหนดจำนวน = ไม่จำกัด */
export const seatLabel = (round: {
  is_full: boolean
  seats_left: number | null
  max_attendees?: number
}): string => {
  if (round.is_full) return 'เต็มแล้ว'
  if (!round.max_attendees || round.seats_left === null) return 'ไม่จำกัดที่นั่ง'

  return `เหลือ ${round.seats_left} ที่นั่ง`
}
